import React from "react";
import Homepage from "./Homepage";
import Projects from "./Projects";
import About from "./About";
import Blog from "./Blog";
import BlogPost from "./BlogPost";


export interface RouteMeta {
    title: string;
    description: string;
    keywords?: string;
    ogImage?: string;
    canonical?: string;
}

export interface RouteConfig {
    path: string;
    component: React.ComponentType;
    meta: RouteMeta;
}

const BASE_URL = "https://darasimi.dev";

export const routes: RouteConfig[] = [
    {
        path: "/",
        component: Homepage,
        meta: {
            title: "Darasimi | Fullstack Engineer",
            description: "Fullstack engineer building fast, scalable web applications with React, Next.js, TypeScript, Node.js, Hono, and PostgreSQL.",
            keywords: "darasimi, dada darasimi, software developer, fullstack engineer, full stack developer, react, website developer, frontend engineer, react developer, typescript, next.js, node.js, hono, postgresql, portfolio",
            ogImage: `${BASE_URL}/favicon.svg`,
            canonical: BASE_URL,
        }
    },
    {
        path: "/projects",
        component: Projects,
        meta: {
            title: "Projects | Darasimi",
            description: "A collection of projects including a social platform for Nigerian stocks, AI-powered tools, a custom SSR server, and high-fidelity landing pages built with React and TypeScript.",
            keywords: "darasimi projects, web development, react projects, next.js, typescript, hono, stukfun",
            canonical: `${BASE_URL}/projects`,
        }
    },
    {
        path: "/about",
        component: About,
        meta: {
            title: "About | Darasimi",
            description: "Fullstack engineer passionate about performance, clean code, and building tools that solve real problems. Experience across financial ERPs, academic platforms, and AI tooling.",
            keywords: "about darasimi, fullstack engineer, frontend engineer, software developer, experience, university of lagos",
            canonical: `${BASE_URL}/about`,
        }
    },
    {
        path: "/blog",
        component: Blog,
        meta: {
            title: "Blog | Darasimi",
            description: "Articles on React, modern web development, and fullstack architecture.",
            keywords: "darasimi blog, frontend blog, react tutorials, web development",
            canonical: `${BASE_URL}/blog`,
        }
    },
    {
        path: "/blog/:slug",
        component: BlogPost,
        meta: {
            title: "Blog | Darasimi",
            description: "Blog post",
            canonical: `${BASE_URL}/blog`,
        }
    }
]

